import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'insufficient-permission',
  templateUrl: './insufficient-permission.component.html',
  styleUrls: ['./insufficient-permission.component.scss'],
  imports: [CommonModule]
})
export class InsufficientPermissionComponent {
}
